import { Injectable } from "@angular/core";
import { BaseEntityService } from "../rest-common.service";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})

export class TdspDealService extends BaseEntityService {

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_TDSP_URL}/deals/`;

  getSupplySources(params = {}) {
    params["start_element"] = 0;
    params["num_element"] = 200;
    let url = this.buildUrl(`${this.resource_url}supply-vendors`, "", params);
    return this.get(url);
  }
}
